/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DeleteSelectedMasterScheduleAllocationsRequest } from '../../models/delete-selected-master-schedule-allocations-request';

export interface DeleteSelectedMasterScheduleAllocations$Params {
      body: DeleteSelectedMasterScheduleAllocationsRequest
}

export function deleteSelectedMasterScheduleAllocations(http: HttpClient, rootUrl: string, params: DeleteSelectedMasterScheduleAllocations$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteSelectedMasterScheduleAllocations.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse>;
    })
  );
}

deleteSelectedMasterScheduleAllocations.PATH = '/api/scheduler/master-schedule/allocations';
